import React from "react";
import { useTranslations } from "@jugl-web/utils";
import { useManageAccountsDrawer } from "@web-src/modules/client-support/pages/ClientSupportPage/components/ManageAccountsDrawer/providers/ManageAccountsDrawerContext";
import { useEmailAccount } from "@web-src/modules/client-support/pages/ClientSupportPage/providers/EmailAccountProvider/useEmailAccount";
import { ChannelTile } from "../ChannelTile";
import { ReactComponent as GmailIcon } from "./assets/gmail.svg";

export const GmailTile: React.FC<{
  isSelected: boolean;
  onSelect: () => void;
}> = (props) => {
  const { t } = useTranslations();
  const { openManageAccountDrawer } = useManageAccountsDrawer();
  const { emailAccount, connectEmailAccount } = useEmailAccount();

  return (
    <ChannelTile
      title={t({
        id: "client-support-page.gmail",
        defaultMessage: "Gmail",
      })}
      isConnected={!!emailAccount?.id}
      onClick={() =>
        emailAccount?.id
          ? openManageAccountDrawer({ name: "emailAccount" })
          : connectEmailAccount()
      }
      description={
        emailAccount?.id
          ? emailAccount.email
          : t({
              id: "cx-ai-agents-page.gmail-connect-description",
              defaultMessage:
                "Connect Gmail to install and preview this channel",
            })
      }
      icon={<GmailIcon />}
      pillText={
        emailAccount?.id
          ? t({
              id: "common.connected",
              defaultMessage: "Connected",
            })
          : undefined
      }
      {...props}
    />
  );
};
